import { render } from "./RecoverPassword.vue?vue&type=template&id=3cf4773a"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
script.render = render

export default script